export default Object.freeze({
    values: {
        1: 'Work',
        2: 'Drive',
        3: 'DriveDistance',
        4: 'DriveRoadTax',
        5: 'DriveCostZone',
        6: 'Unknown',
    },

    Work: {
        name: 'Work',
        value: 1,
        inHours: true,
        display: "servicesystem.common_objects.article.type_work",
        icon: 'mdi-clock-outline'
    },
    Drive: {
        name: 'Drive',
        value: 2,
        inHours: true,
        display: "servicesystem.common_objects.article.type_drive",
        icon: 'mdi-car-clock'
    },
    DriveDistance: {
        name: 'DriveDistance',
        value: 3,
        inHours: false,
        display: "servicesystem.common_objects.article.type_drive_distance",
        icon: 'mdi-map-marker-distance'
    },
    DriveRoadTax: {
        name: 'DriveRoadTax',
        value: 4,
        inHours: false,
        display: "servicesystem.common_objects.article.type_drive_road_tax",
        icon: 'mdi-boom-gate-arrow-up-outline'
    },
    DriveCostZone: {
        name: 'DriveCostZone',
        value: 5,
        inHours: false,
        display: "servicesystem.common_objects.article.type_drive_cost_zone",
        icon: 'mdi-road-variant'
    },
    Unknown: {
        name: 'Unknown',
        value: 6,
        inHours: false,
        display: "servicesystem.common_objects.article.article",
        icon: '$article'
    },
});